import { sendDelete, sendGet, sendPost, sendPut } from "api/restUtil";
import {useEffect, useMemo, useState} from 'react';
import SearchList from 'components/SearchList';
import ReactDataTableDisplay from 'components/DataTable/ReactDataTableDisplay';
import { getTodayStr } from "js/common";
import ExcelButton from "components/button/ExcelButton";

// 퀵커머스 정산 조회
function QuickCommerceSettle() {

	//데이터 목록
	const [ dataList, setDataList ] = useState([]);
	//초기 검색 조건 데이터
	const [ initialCondition, setInitialCondition] = useState({});
	//검색 데이터
	const [ condition, setCondition] = useState({});
	// 페이지 정보
	const [ pagingInfo, setPagingInfo ] = useState({});

	//검색 조건
	const conditionList = [
		{
			title : "조회일",
			col : "searchDate",
			type : "datePicker",
			required: true,
		},
		{
			title : "표시건수",
			col : "pageSize",
			type : "select",
			option: [
				{label: "10개씩보기", value: 10},
				{label: "20개씩보기", value: 20},
				{label: "50개씩보기", value: 50},
				{label: "100개씩보기", value: 100},
				{label: "1000개씩보기", value: 1000},
			],
		},
	];
	
	
	
	//데이터 테이블 컬럼
	const columns = useMemo(() =>[
		{ header : "결제일", col : "payDate", cellWidth: "100"},
		{ header : "정산기준일", col : "settleBasisDate", cellWidth : "100" },
		{ header : "정산예정일", col : "settleExpectDate", cellWidth : "100" },
		{ header : "지점명", col : "branchName", cellWidth : "100" },
		{ header : "주문번호", col : "orderId", cellWidth : "100" },
		{ header : "상품주문번호", col : "productOrderId", cellWidth : "100" },
		{ header : "정산유형", col : "settleObjectType", cellWidth : "100" },
		{ header : "정산상태", col : "cancelType", cellWidth : "100" },
		{ header : "거래금액", col : "tradeAmount", type: "number", cellWidth : "100" },
		{ header : "판매자부담할인", col : "sellerCostProductOrderDiscountAmount", type: "number", cellWidth : "100" },
		{ header : "네이버할인지원금", col : "naverCostDiscountAmount", type: "number", cellWidth : "115" },
		{ header : "결제금액", col : "payAmount", type: "number", cellWidth : "100" },
		{ header : "정산기준금액", col : "settleBasisAmount", type: "number", cellWidth : "100" },
		{ header : "주문관리수수료", col : "payCommissionAmount", type: "number", cellWidth : "100" },
		{ header : "매출연동수수료", col : "sellingInterlockCommissionAmount", type: "number", cellWidth : "100" },
		{ header : "정산금액", col : "settleAmount", type: "number", cellWidth : "100" },
	], []);

	useEffect(() =>{
		const initData = async () => {
			
			//초기 검색 조건
			const today = getTodayStr();
			const newCond = {searchDate: today, pageSize: 20};
			setInitialCondition(newCond);
			searchList(newCond);
		};

		initData();

	}, []);


	//목록 조회
	const searchList = async (cond = {}) => {
		const tmpCond = {...cond};

		if(tmpCond.pageNo) tmpCond.pageNumber = tmpCond.pageNo;

		let result = await sendGet("/api/settle/quick-commerce", tmpCond);
		if(result.respCode === "SUCCESS"){

			setCondition(cond);

			setDataList(result.data.elements);

			// result.data.pagination => {page, size, totalPages, totalElements}
			const rcvPageInfo = result.data.pagination;	// 길어서 줄이기 위해 변수에 설정.
			const pageInfo = {
				cntPerPage: rcvPageInfo.size,
				pageNo: rcvPageInfo.page,
				totalCnt: rcvPageInfo.totalElements,
				searchFnc: searchList,
				searchCond: cond,
			};
			setPagingInfo(pageInfo);
			// setPageInfo(result.data.data.pagination);
			// <DataTablePaging cntPerPage={pagingInfo.cntPerPage} pageNo={pagingInfo.pageNo} totalCnt={pagingInfo.totalCnt} searchFnc={pagingInfo.searchFnc} searchCond={pagingInfo.searchCond} />
		}
	}

	return (
		<div className="ant-tabs-tabpane">
			<SearchList conditionList={conditionList} onSearch={searchList} initialData={initialCondition} />
			<div className="table-buttons mg-t-10 mg-b-10">
				<ExcelButton
					columns={columns}
					data={dataList}
					fileName={"정산_" + getTodayStr().replace(/-/g, "") + "_" + pagingInfo.pageNo + ".xlsx"}
					sheetName={"정산내역"}
				/>
			</div>

			<ReactDataTableDisplay
				columns={columns}
				customDatas={dataList}
				hideCheckBox={true}
				// percentageWidth={true}
				isPageNation={false}
				pagingInfo={pagingInfo}
				// rowClick={"checkbox"}
			/>

		</div>
	);
}

export default QuickCommerceSettle;